import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Route, withRouter } from "react-router";

import Gretting from "../../../utils/gretting";
import { getUserData } from "../../../utils/localStorage";
import * as actions from "../../../store/actions";


import "./index.css";

import RequestAppointments from "./RequestAppointments";
import ScheduledAppointment from "./ScheduledAppointment";
import VisitNow from "./VisitNow";
import Tabs from "../../../components/uiElements/navTabs/Tabs";
import AppointmentDetail from "./AppointmentDetail";
import { getDashboardPath, getOnboardingPath } from "../../../constants";

import PriceModal from "./PopupModal/PriceModal";
import LockNoteModal from "./PopupModal/LockNoteModal";
import SubscriptionReminder from "../../../components/uiElements/modal/SubscriptionReminder";

const Appointments = ({
  personalisedExperience,
  practiceDetails,
  personalInfo,
  appointments,
  match,
  history,
  location,
  templates,
  addNoteLock,
  addTemplate,
  clearTemplateData,
  setAppointmentData,
  updateAvailablePermission,
  getAvailablePermission,
  captureHoldAmount,
  currentAppointment,
}) => {
  const { path } = match;
  const userData = getUserData();
  const [subscriptionModal, setShowSubscriptionModal] = useState(false);

  const visitNowData = useSelector(state => state.dashboard?.ongoingAppointment?.visitNow);

  useEffect(() => {
    getAvailablePermission();

    userData.doctor_subscription_details?.length == 0
      ? subscriptionModalOperator(true)
      : subscriptionModalOperator(false);
  }, [getAvailablePermission]);



  const subscriptionModalOperator = value => {
    setShowSubscriptionModal(value);
  };

  let currentTab = history?.location?.pathname.split("/").pop();
  currentTab = currentTab === "appointments" ? "visit-now" : currentTab;

  const tabs = [
    {
      name: "visit-now",
      value: `Visit Now (${
        Object.keys(appointments?.visitNow).length > 0 ? 1 : 0
      })`,
      to: path,
    },
    {
      name: "scheduled",
      value: `Scheduled (${appointments.noOfScheduledAppointments || 0})`,
      to: `${path}/scheduled`,
    },
    {
      name: "requests",
      value: `Requests (${appointments.noOfRequestedAppointments || 0})`,
      to: `${path}/requests`,
    },
  ];

  const [modal, setShowModal] = useState(location?.state?.callEnded ? 1 : 0);
  const [fees, setFees] = useState(
    userData?.id === currentAppointment?.doctor?.id
      ? currentAppointment?.doctor?.fees ||
          currentAppointment?.doctor_detail?.fees
      : userData?.id === currentAppointment?.guest_doctor?.id
      ? currentAppointment?.guest_doctor?.fees
      : currentAppointment?.doctor_detail?.fees
  );

  const curTemplate = { ...templates };

  const { notesImages, ...template } = curTemplate;

  const showNoteModal = Object.keys(template)?.length > 0;

  console.log("Apoointemtns<><><>",appointments)

  return (
    <>
      {subscriptionModal && (
        <SubscriptionReminder
          isOpen={subscriptionModal}
          onSuccess={() => {
            history.push(getOnboardingPath("/step6"));
          }}
          closeModal={() => setShowSubscriptionModal(!subscriptionModal)}
        />
      )}

      {(userData?.logo_url || personalisedExperience?.logo?.length > 0) && (
        <img
          src={
            userData?.logo_url ||
            personalisedExperience?.logo?.[0]?.src ||
            URL.createObjectURL(personalisedExperience?.logo?.[0])
          }
          alt="logo"
          width={56}
          height={56}
          className="mr-2"
        />
      )}
      <span className="appointment-font">{practiceDetails.practiceName}</span>
      <p className="mt-2">
        <span className="gretting">{Gretting()},</span>{" "}
        <span className="appointment-font-secondary">
          Dr. {userData?.firstName} {userData?.lastName}!
        </span>
      </p>
      <div className="availableNow custom-switch custom-switch-md left">
        <input
          type="checkbox"
          className="custom-control-input"
          id="customSwitches"
          onChange={e => {
            updateAvailablePermission(e.target.checked);
          }}
          checked={appointments.is_available}
        />
        <label className="custom-control-label" htmlFor="customSwitches">
          <span>Available Now</span>
        </label>
      </div>
      <div className="appointment-container mx-n4">
        <Tabs tabs={tabs} activeTab={currentTab} />
        {process.env.NODE_ENV === 'development' && (
          <div style={{ margin: '10px' }}>
            <button 
              onClick={() => {
                // Mock visit now appointment for testing
                const mockAppointment = {
                  id: 'test-123',
                  doctor_status: 'REQUESTED',
                  patient: {
                    first_name: 'Test',
                    last_name: 'Patient',
                    image: null,
                    id: 1
                  },
                  doctor: {
                    first_name: 'Dr. Test',
                    last_name: 'Doctor'
                  },
                  topic: 'Test Visit Now'
                };
                // Dispatch to store - preserve existing data
                setAppointmentData({ 
                  ...appointments,
                  visitNow: mockAppointment 
                });
              }}
              style={{ padding: '5px 10px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', marginRight: '10px' }}
            >
              🧪 Test Visit Now Ring
            </button>
            <button 
              onClick={() => {
                setAppointmentData({ 
                  ...appointments,
                  visitNow: {} 
                });
              }}
              style={{ padding: '5px 10px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px' }}
            >
              🛑 Clear Test
            </button>
          </div>
        )}
      </div>
      <Route exact path={path} component={VisitNow} />
      <Route
        exact
        path={`${path}/scheduled`}
        component={ScheduledAppointment}
      />
      <Route exact path={`${path}/requests`} component={RequestAppointments} />
      <Route
        exact
        path={getDashboardPath("/appointments/detail/:id")}
        component={AppointmentDetail}
      />

      <PriceModal
        fees={fees}
        maxFee={fees}
        isOpen={modal === 1}
        closeModal={() => {
          setShowModal(2);
          history.push(getDashboardPath("/appointments"));
        }}
        onUpdate={setFees}
        onSuccess={() => {
          captureHoldAmount(fees, () => {
            setShowModal(2);
          });
          history.push(getDashboardPath("/appointments"));
        }}
      />

      <LockNoteModal
        isOpen={modal === 2 && showNoteModal}
        onLock={() =>
          addNoteLock(() => {
            clearTemplateData();
            setShowModal(0);
          })
        }
        onSaveAsTemplate={() => {
          addTemplate(() => {
            addNoteLock(() => {
              clearTemplateData();
              setShowModal(0);
            });
          });
        }}
        closeModal={() => setShowModal(!modal)}
      />
    </>
  );
};

const mapStoreToProps = ({ onboarding, dashboard }) => ({
  templates: dashboard.templates.currentData,
  personalisedExperience: onboarding.personalisedExperience,
  practiceDetails: onboarding.practiceDetails,
  personalInfo: onboarding.personalInfo,
  appointments: dashboard.appointments,
  currentAppointment: dashboard?.ongoingAppointment?.currentAppointment,
});

const mapDispatchToProps = dispatch => ({
  setAppointmentData: updatedData =>
    dispatch(actions.setAppointmentData(updatedData)),
  addTemplate: cb => dispatch(actions.addTemplate(cb)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  addNoteLock: cb => dispatch(actions.addNoteLock(cb)),
  updateAvailablePermission: is_available =>
    dispatch(actions.updateAvailablePermission(is_available)),
  getAvailablePermission: () => dispatch(actions.getAvailablePermission()),
  captureHoldAmount: (fees, cb) =>
    dispatch(actions.captureHoldAmount(fees, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(Appointments)
);
